// extracted by mini-css-extract-plugin
module.exports = {"freeShippingContainer":"FreeShippings_freeShippingContainer__TRbLY","freeShippingContainerPY":"FreeShippings_freeShippingContainerPY__1GdxI"};